var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "file"]
var hoisted2 = ["class", "name icon icon-file-text"]
var hoisted3 = ["class", "file-name"]
var hoisted4 = ["class", "expanded"]
var hoisted5 = ["class", "fa fa-angle-down"]
var hoisted6 = ["class", "collapsed"]
var hoisted7 = ["class", "fa fa-angle-right"]
var hoisted8 = ["class", "name icon icon-file-directory"]
var hoisted9 = ["class", "dir-name"]
var hoisted10 = ["class", "triangle-left"]
var __target

module.exports = function tree (ctrl, data, root) {
  var isRoot = root === data[0]
      var current = ctrl.current
      function sorter (a, b) {
        if (a.fso.isDirectory) {
          if (b.fso.isDirectory) {
            return a.name.toLowerCase()
  < b.name.toLowerCase() ? -1 : 1
          } else {
            return -1
          }
        } else {
          if (b.fso.isDirectory) {
            return 1
          } else {
            return a.name.toLowerCase()
  < b.name.toLowerCase() ? -1 : 1
          }
        }
      }
      data.sort(sorter)
  elementOpen("ul", null, null, "class", isRoot ? 'tree noselect' : 'noselect')
    __target = data
    if (__target) {
      ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
        var node = $value
        var $key = "196996bf-8ba2-439b-b217-80e98fbe0f3d_" + node.path
        elementOpen("li", $key, null, "oncontextmenu", function ($event) {
          var $element = this;
        ctrl.onRightClick($event, node)}, "title", node.fso.getRelativePath(), "class", node.fso.isDirectory ? 'dir' : 'file' + (node.fso === current ? ' selected' : ''))
          var fso = node.fso
                  var isExpanded = ctrl.isExpanded(fso)
          if (!fso.isDirectory) {
            elementOpen("a", "eb6472e0-d7ca-4235-973b-c9419b24c333_" + $key, hoisted1, "onclick", function ($event) {
              var $element = this;
            ctrl.main.setCurrentFile(fso)})
              elementOpen("span", "fd7d193d-fe77-4145-b2d5-706fffc704ac_" + $key, hoisted2, "data-name", fso.name)
              elementClose("span")
              elementOpen("span", "8e69c780-9607-46ad-bf8d-774fbba0316e_" + $key, hoisted3)
                text("" + (fso.name) + "")
              elementClose("span")
            elementClose("a")
          }
          if (fso.isDirectory) {
            elementOpen("a", null, null, "onclick", function ($event) {
              var $element = this;
            ctrl.onClick(fso)})
              if (isExpanded) {
                elementOpen("small", "a844c04a-85a4-4e44-bdc8-65c6db631ecf_" + $key, hoisted4)
                  elementOpen("i", "10aa11f5-512f-46f4-baad-9fcef35d5010_" + $key, hoisted5)
                  elementClose("i")
                elementClose("small")
              }
              if (!isExpanded) {
                elementOpen("small", "76c9eba9-8bae-4bb2-b59a-073fb1c11f04_" + $key, hoisted6)
                  elementOpen("i", "02dea1a8-e873-4abb-a080-da6aa8c72443_" + $key, hoisted7)
                  elementClose("i")
                elementClose("small")
              }
              elementOpen("span", "3959f76d-fe65-486e-836f-5ef38fc01ecf_" + $key, hoisted8, "data-name", fso.name)
              elementClose("span")
              elementOpen("span", "0142e03c-0618-4a32-a9db-29dc792894c7_" + $key, hoisted9)
                text("" + (fso.name) + "")
              elementClose("span")
            elementClose("a")
          }
          if (!fso.isDirectory && fso === current) {
            elementOpen("span", "602faaed-2446-49d9-9e08-36daecd63ffa_" + $key, hoisted10)
            elementClose("span")
          }
          if (fso.isDirectory && isExpanded) {
            tree(ctrl, node.children, root)
          }
        elementClose("li")
      }, this)
    }
  elementClose("ul")
}
